import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Apply from './pages/Apply';
import Documents from './pages/Documents';
import Interview from './pages/Interview';
import SignContract from './pages/SignContract';
import WizardRoute from './components/Wizard/WizardRoute';

// Wizard Pages
import FitAssessment from './pages/Wizard/FitAssessment';
import LocalKnowledge from './pages/Wizard/LocalKnowledge';
import VideoIntro from './pages/Wizard/VideoIntro';
import UploadDocuments from './pages/Wizard/UploadDocuments';
import DocumentReview from './pages/Wizard/DocumentReview';
import ScheduleInterview from './pages/Wizard/ScheduleInterview';
import InterviewScheduled from './pages/Wizard/InterviewScheduled';
import InterviewComplete from './pages/Wizard/InterviewComplete';
import BackgroundCheck from './pages/Wizard/BackgroundCheck';
import Approved from './pages/Wizard/Approved';
import { APPLICANT_BASE_PATH } from './config';

function App() {
  return (
    <Router basename={APPLICANT_BASE_PATH || undefined}>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/contract" element={<SignContract />} />
        <Route path="/sign-contract" element={<SignContract />} />

        {/* Legacy routes (keep for backward compatibility) */}
        <Route path="/documents" element={<Documents />} />
        <Route path="/interview" element={<Interview />} />

        {/* Wizard routes */}
        <Route
          path="/wizard/fit-assessment"
          element={
            <WizardRoute>
              {(applicationStatus) => <FitAssessment applicationStatus={applicationStatus} />}
            </WizardRoute>
          }
        />
        <Route
          path="/wizard/local-knowledge"
          element={
            <WizardRoute>
              {(applicationStatus) => <LocalKnowledge applicationStatus={applicationStatus} />}
            </WizardRoute>
          }
        />
        <Route
          path="/wizard/video-intro"
          element={
            <WizardRoute>
              {(applicationStatus) => <VideoIntro applicationStatus={applicationStatus} />}
            </WizardRoute>
          }
        />
        <Route
          path="/wizard/upload-documents"
          element={
            <WizardRoute>
              {(applicationStatus) => <UploadDocuments applicationStatus={applicationStatus} />}
            </WizardRoute>
          }
        />
        <Route
          path="/wizard/document-review"
          element={
            <WizardRoute>
              {(applicationStatus) => <DocumentReview applicationStatus={applicationStatus} />}
            </WizardRoute>
          }
        />
        <Route
          path="/wizard/schedule-interview"
          element={
            <WizardRoute>
              {(applicationStatus) => <ScheduleInterview applicationStatus={applicationStatus} />}
            </WizardRoute>
          }
        />
        <Route
          path="/wizard/interview-scheduled"
          element={
            <WizardRoute>
              {(applicationStatus) => <InterviewScheduled applicationStatus={applicationStatus} />}
            </WizardRoute>
          }
        />
        <Route
          path="/wizard/interview-complete"
          element={
            <WizardRoute>
              {(applicationStatus) => <InterviewComplete applicationStatus={applicationStatus} />}
            </WizardRoute>
          }
        />
        <Route
          path="/wizard/background-check"
          element={
            <WizardRoute>
              {(applicationStatus) => <BackgroundCheck applicationStatus={applicationStatus} />}
            </WizardRoute>
          }
        />
        <Route
          path="/wizard/approved"
          element={
            <WizardRoute>
              {(applicationStatus) => <Approved applicationStatus={applicationStatus} />}
            </WizardRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
